import apiClient, { safeJson } from '@/api/client';
import { MemberCoachListResponse } from './types';

/** 배정된 강사 목록 조회 (centerId 전달 시 해당 센터로 스코핑) */
export const getMemberCoaches = async (memberId: string, centerId?: string) => {
    const res = await apiClient.get(
        `v3/members/${memberId}/coaches`,
        centerId ? { searchParams: { centerId } } : undefined
    );
    const data = await safeJson(res);
    return { status: res.status, data: data as MemberCoachListResponse | null };
};

/** 강사 추가 배정 */
export const addMemberCoach = async (memberId: string, coachId: string, centerId?: string) => {
    const res = await apiClient.post(`v3/members/${memberId}/coaches`, { json: { coachId, centerId } });
    const data = await safeJson(res);
    return { status: res.status, data };
};

/** 대표 강사 변경 */
export const updatePrimaryMemberCoach = async (memberId: string, coachId: string, centerId?: string) => {
    const res = await apiClient.patch(`v3/members/${memberId}/coaches/primary`, {
        json: { coachId, centerId },
    });
    const data = await safeJson(res);
    return { status: res.status, data };
};

/** 강사 제거 */
export const removeMemberCoach = async (memberId: string, coachId: string, centerId?: string) => {
    const res = await apiClient.delete(
        `v3/members/${memberId}/coaches/${coachId}`,
        centerId ? { searchParams: { centerId } } : undefined
    );
    const data = await safeJson(res);
    return { status: res.status, data };
};
